module.exports = __webpack_public_path__ + "images/contact-team-artur.png?h=beda85273a6121c9ad171915489a7f98";


//////////////////
// WEBPACK FOOTER
// ./src/components/public/contact/Team/images/contact-team-artur.png
// module id = 2875
// module chunks = 48